import React, { useEffect, useState } from 'react';
import styles from './LocationList.module.css';
import { MdStar, MdStarBorder } from 'react-icons/md';
import { TbRotateClockwise2 } from 'react-icons/tb';
import { BreathAPIs } from '../../../../APIs/BreathAPIs';
import store from '../../../../store';
import { loadUser } from '../../../../Actions/Auth';

const FavoriteIcon = ({ isFavorite, locationId, resultFavLocations }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isFav, setIsFav] = useState(isFavorite);

    useEffect(() => {
        setIsFav(isFavorite);
    }, [isFavorite]);

    const makeFavorite = async (event, locationId) => {
        event.stopPropagation();
        

        try {
            setIsSubmitting(true);
            const result = await BreathAPIs.updateFavoriteLocation(locationId);
            if(result.data.success) {
                resultFavLocations(result.data.favLocations)
                if(result.data.isAdded) {
                    setIsFav(true);
                }
                else {
                    setIsFav(false);
                }
            }
            setIsSubmitting(false);
            store.dispatch(loadUser());
        } catch (error) {
            console.error("Error updating favorite status", error);
            setIsSubmitting(false);
        }
    };

    return (
        <span className={styles['favorite']} onClick={(event) => makeFavorite(event, locationId)}>
            {isSubmitting ? (
                <TbRotateClockwise2 className={styles['rotating']} />
            ) : (
                isFav ? <MdStar /> : <MdStarBorder />
            )}
        </span>
    );
};

export default FavoriteIcon;
